import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

interface IInformationPopoverProps {
  text: string;
  color?: string;
}

export const InformationPopover: React.FC<IInformationPopoverProps> = ({
  text,
  color
}) => {

  return text ?
    <span style={{ marginLeft: '5px' }}>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip>{text}</Tooltip>}
      >
        <span><FontAwesomeIcon icon={faInfoCircle} color={color || 'gray'} size='sm' /></span>
      </OverlayTrigger>
    </span>
  : null;

}